export const HTTP_GET = 'GET' as const;
export const HTTP_POST = 'POST' as const;
export const HTTP_DELETE = 'DELETE' as const;
export const HTTP_PUT = 'PUT' as const;
export const HTTP_PATCH = 'PATCH' as const;
export const HTTP_HEAD = 'HEAD' as const;
export const HTTP_OPTIONS = 'OPTIONS' as const;

export const HTTP_CONTENT_TYPE_HEADER = 'Content-Type' as const;
export const HTTP_CONTENT_TYPE_JSON = 'application/json' as const;
export const HTTP_CONTENT_TYPE_MULTIPART = 'multipart/form-data' as const;

export type HTTP_METHOD =
  | typeof HTTP_GET
  | typeof HTTP_POST
  | typeof HTTP_DELETE
  | typeof HTTP_PUT
  | typeof HTTP_PATCH
  | typeof HTTP_HEAD
  | typeof HTTP_OPTIONS;
